import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';
import {connect} from 'react-redux';
import {CloseX} from '../Components/CloseX'




const logoStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    height: '20px',
    margin: '2px'
};


const contentStyle : CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
};

const styleStyle : CSSProperties = {
    height: '20px',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '3px',
    maxWidth: '100%'
};

const styleNoPicStyle : CSSProperties = {
    height: '40px',
    fontSize: '24px',
    lineHeight: '40px',
    letterSpacing: '5px'
};


class CardProps{
    design: Tgcc.Design;
    onSelect: (design : Tgcc.Design) => void;
    onZoom: (design: Tgcc.Design) => void;
}

const wrapperStyle : CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    fontFamily: 'CenturyGothic',
    fontSize: '8px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    margin: '5px',
    height:'300px',
    width:'215px',
    '@media (max-width:800px) and (max-height:1280px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'10px auto'
    },
    '@media (max-width:414px)': {
        margin:'auto 10px 10px auto'
    }
};

const footerButtonStyle: CSSProperties = {
    fontSize: '10px',
    letterSpacing: '4px',
    alignSelf: 'center',
    cursor: 'pointer',
    display:'none'
}

const imageStyle : CSSProperties = {
    cursor: 'pointer',
    height:'268px',
    width:'200px'
};

const designIdStyle : CSSProperties = {
    alignSelf: 'center',
    height: '15px',
    lineHeight: '15px',
    margin: '3px',
    fontFamily: 'CenturyGothic',
    fontSize: '13px',
    letterSpacing: '3px',
};

class _DesignCard extends React.Component<CardProps,any> {

    handleSelection = (evt) => {
        this.props.onSelect(this.props.design);
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    viewFullSizeDesign = () => { this.props.onZoom(this.props.design)}
    
    render() {
        let cardImage = Tgcc.getDesignPath(this.props.design.thumbnail);
        let designId = this.props.design.id;
        let img = Tgcc.getDesignPath(this.props.design.thumbnail)
        return (
            <div style={wrapperStyle}>
                <div style={designIdStyle}>{designId}</div>
                <div style={contentStyle} onClick={this.viewFullSizeDesign}>
                    <img style={imageStyle} src={cardImage.replace(' ', '%20')} alt={cardImage} onError={this.handleImageError} />
                </div>
                <div className="hoverBorder" style={footerButtonStyle} onClick={this.handleSelection}>add to proof</div>
            </div>
        )
    }
}

export var DesignCard = Radium(_DesignCard);